module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content has-text-centered",
    class: {
      'direction-rtl': _vm.Language == 'fa' || _vm.Language == 'ar'
    }
  }, [_c('div', {
    staticClass: "modal",
    class: {
      'is-active': _vm.vloadPromo.modalActive
    },
    attrs: {
      "id": "vloadPromoModal"
    }
  }, [_c('div', {
    staticClass: "modal-background"
  }), _vm._v(" "), _c('div', {
    staticClass: "modal-card"
  }, [_c('header', {
    staticClass: "modal-card-head"
  }, [_c('button', {
    staticClass: "delete custom-delete",
    on: {
      "click": function($event) {
        _vm.vloadPromo.modalActive = false
      }
    }
  })]), _vm._v(" "), _c('section', {
    staticClass: "modal-card-body"
  }, [_c('div', {
    staticClass: "vload-promo-steps-content"
  }, [_c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column is-8 has-text-left-desktop has-text-left-tablet",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('deposit_page_desc'))
    }
  }), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column is-8 has-text-white has-text-weight-bold"
  }, [_c('p', {
    staticClass: "has-text-left is-size-6 custom-mt"
  }, [_vm._v(_vm._s(_vm.$t('deposit_page_desc1')))]), _vm._v(" "), _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('img', {
    attrs: {
      "width": "50%",
      "src": require("../../assets/img/promo/vload/account.svg")
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "vload-promo-step"
  }, [_vm._v(_vm._s(_vm.$t('create_new_account')))])]), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('img', {
    attrs: {
      "width": "50%",
      "src": require("../../assets/img/promo/vload/evoucher.svg")
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "vload-promo-step"
  }, [_vm._v(_vm._s(_vm.$t('successfully_purchase_vload')))])]), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('img', {
    attrs: {
      "width": "50%",
      "src": require("../../assets/img/promo/vload/tier2.svg")
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "vload-promo-step"
  }, [_vm._v(_vm._s(_vm.$t('upgrade_to_tier_2')))])])])]), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('a', {
    staticClass: "vload-promo-register-btn is-size-6-desktop is-size-7-tablet is-size-8-mobile",
    attrs: {
      "target": "_blank",
      "href": "https://vload.expert/register?_referral=nkwwci6z96ytgm4qj9cx"
    }
  }, [_vm._v(_vm._s(_vm.$t('register_now')))])])])])])])]), _vm._v(" "), (_vm.User.info) ? _c('new-terms-modal', {
    attrs: {
      "user-id": _vm.User.info.ID
    }
  }) : _vm._e(), _vm._v(" "), _c('transition', {
    attrs: {
      "appear": "",
      "name": "fadeside",
      "mode": "out-in"
    }
  }, [(_vm.step == 1) ? _c('div', {
    key: "images"
  }, [_c('div', {
    staticClass: "tile is-ancestor"
  }, [_c('div', {
    staticClass: "tile is-12 is-vertical"
  }, [_c('div', {
    staticClass: "tile is-parent is-unselectable"
  }, [_c('article', {
    staticClass: "tile is-parent is-12 is-paddingless has-text-left"
  }, [_c('h3', {
    staticClass: "clear-margin"
  }, [_vm._v(_vm._s(_vm.$t('select_payment_method').tUpper()))])])]), _vm._v(" "), _c('div', {
    staticClass: "tile is-parent"
  }, [_c('article', {
    staticClass: "tile is-child"
  }, [_c('div', {
    staticClass: "columns is-multiline pmethods"
  }, _vm._l((_vm.paymentImages), function(img, name) {
    return (_vm.checkPSP(img, name)) ? _c('div', {
      key: img.PSPName,
      staticClass: "column is-3",
      on: {
        "click": function($event) {
          return _vm.selectPaymentMethod(name)
        }
      }
    }, [_c('div', {
      staticClass: "box"
    }, [(name === 'bankwire' && _vm.Language == 'it') ? _c('img', {
      attrs: {
        "src": img.pathIT
      }
    }) : _c('img', {
      attrs: {
        "src": img.path
      }
    })])]) : _vm._e()
  }), 0)])])])])]) : _vm._e(), _vm._v(" "), (_vm.step == 2) ? _c('div', {
    key: "component",
    staticClass: "tile is-ancestor form-container"
  }, [_c('div', {
    staticClass: "tile is-12 is-parent"
  }, [_vm._l((_vm.paymentImages), function(img, name) {
    return (_vm.selected.paymentMethod == name) ? _c('div', {
      key: name,
      staticClass: "tile is-11 is-parent"
    }, [_c('div', {
      staticClass: "tile is-3"
    }, [_c('figure', {
      staticClass: "image is-100x100"
    }, [(name === 'bankwire' && _vm.Language == 'it') ? _c('img', {
      attrs: {
        "src": img.pathIT
      }
    }) : _c('img', {
      attrs: {
        "src": img.path
      }
    })])]), _vm._v(" "), _c('div', {
      staticClass: "tile is-9"
    }, [_c('div', [_c('span', {
      staticClass: "title",
      class: {
        'has-text-right': _vm.Language == 'fa' || _vm.Language == 'ar', 'has-text-left': _vm.Language != 'fa' && _vm.Language != 'ar'
      }
    }, [_vm._v(_vm._s(_vm.$t(img.T)))]), _vm._v(" "), _c('article', {
      staticClass: "tile is-child psp"
    }, [_c(_vm.paymentImages[_vm.selected.paymentMethod].Component, {
      tag: "component",
      attrs: {
        "selected": _vm.selected,
        "apm": img.Component != name ? name : null
      }
    })], 1)])])]) : _vm._e()
  }), _vm._v(" "), _c('div', {
    staticClass: "tile is-1"
  }, [_c('div', {
    staticClass: "topNav"
  }, [_c('a', {
    staticClass: "button",
    on: {
      "click": function($event) {
        _vm.step--, (_vm.selected.paymentMethod = '')
      }
    }
  }, [_c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "fa fa-chevron-circle-left",
    class: {
      'ml-10': _vm.Language == 'fa' || _vm.Language == 'ar'
    }
  })]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('back')))])])])])], 2)]) : _vm._e()]), _vm._v(" "), (_vm.selected.paymentMethod == 'vload') ? _c('a', {
    staticClass: "vload-ref-link",
    on: {
      "click": function($event) {
        _vm.vloadPromo.modalActive = true
      }
    }
  }, [_c('img', {
    attrs: {
      "width": "800px",
      "src": require("../../assets/img/promo/vload/vload-promo-banner.png")
    }
  })]) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "column"
  }, [_c('img', {
    staticClass: "vload-promo-logo",
    attrs: {
      "src": require("../../assets/img/promo/vload/vload-logo.svg")
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-443969b4"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/finance/Deposit.vue
// module id = 762
// module chunks = 0